<template>
  <div class="user-agreement">
    <div>
      <strong>Gebruikersvoorwaarden</strong>
    </div>
    <br />
    <div>
      Deze gebruikersvoorwaarden gelden voor iedere gebruiker van onze website
      (<a href="https://www.rentrunner.eu">www.rentrunner.eu</a>), alsook voor
      de informatie, nieuwsbrieven, nieuwsberichten en diensten die op of via
      <a href="https://www.rentrunner.eu">www.rentrunner.eu</a> zijn te
      raadplegen.
    </div>
    <br />
    <div class="underline">Disclaimer</div>
    <p>
      De informatie op
      <a href="https://www.rentrunner.eu">www.rentrunner.eu</a> is uitsluitend
      bedoeld als algemene informatie en mag slechts ter algemene kennisname
      gebruikt worden. De informatie die wij verstrekken op de website is
      uitdrukkelijk geen advies. De informatie op de website en in onze
      nieuwsbrieven is met de grootst mogelijke zorgvuldigheid samengesteld.
      RentRunner kan echter niet garanderen dat alle informatie volledig, juist,
      actueel en/of vrij van schrijffouten is. Tevens kan RentRunner niet
      garanderen dat de website en mailings vrij zijn van virussen, malware of
      phishing. RentRunner is niet aansprakelijk voor mogelijke schrijffouten,
      onjuistheid, onvolledigheid, gedateerdheid, virussen, malware, phishing,
      overige digitale ‘gevaren’ of het niet (correct) functioneren van de
      website. Daar waar wordt verwezen naar andere websites of documenten van
      derden kan geen enkele garantie worden gegeven op functionaliteit,
      juistheid of volledigheid. RentRunner is niet aansprakelijk voor de inhoud
      en het functioneren van websites waarnaar eventueel verwezen wordt op
      <a href="https://www.rentrunner.eu">www.rentrunner.eu</a>, onder meer nu
      wij geen invloed hebben op de beveiliging daarvan. Het gebruik van onze
      website en de daarop weergegeven informatie is aldus volledig voor uw
      eigen rekening en risico.
    </p>
    <p>
      De inhoud van de website
      <a href="https://www.rentrunner.eu">www.rentrunner.eu</a> wordt beheerd
      door RentRunner en/of door RentRunner ingeschakelde derden en heeft
      uitsluitend tot doel informatie te verschaffen over RentRunner en haar
      diensten, alsook om het gebruik dan wel afmelden van een vervangende auto
      te beheren. De informatie wordt aangeboden zonder enige vorm van garantie.
      Ondanks het feit dat zorgvuldigheid is betracht bij de samenstelling van
      deze website kan het voorkomen dat de weergegeven informatie na verloop
      van tijd is achterhaald. RentRunner is in geen geval aansprakelijk voor
      directe of indirecte schade voortvloeiend uit het gebruik van deze
      website. RentRunner behoudt zich het recht voor om op elk moment de inhoud
      van de website en de inhoud van deze disclaimer en gebruikersvoorwaarden
      aan te passen of onderdelen van de website te verwijderen zonder daarover
      mededeling te (hoeven) doen. De informatie op de website is vrijblijvend
      en geldt niet als een specifiek aanbod om een overeenkomst te sluiten. Op
      diverse plaatsen in deze website wordt u de gelegenheid geboden om per
      e-mail met ons te communiceren. U moet zich hierbij wel realiseren dat wij
      u, bij deze vorm van communicatie, geen vertrouwelijkheid kunnen
      garanderen.
    </p>
    <div class="underline">Intellectuele eigendom</div>
    <p>
      Alle intellectuele eigendomsrechten met betrekking tot deze website en de
      inhoud ervan, berusten uitsluitend bij RentRunner. Het is de gebruiker van
      deze website derhalve niet toegestaan om (delen van) de website en de
      nieuwsbrieven, ongeacht de verschijningsvorm ervan, te wijzigen, bewerken,
      openbaar te maken, kopiëren, vermenigvuldigen, distribueren, (tegen
      vergoeding) beschikbaar te stellen aan derden, of op enige andere wijze te
      gebruiken, zonder expliciete schriftelijke toestemming van RentRunner.
    </p>
    <p>
      RentRunner is een geregistreerde, beschermde handelsnaam van RentRunner
      B.V.
    </p>
  </div>
</template>

<script>
export default {
  name: "user-agreement",
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.user-agreement {
  padding: 40px;
}
.underline {
  text-decoration: underline;
}
</style>
